<template>
  <div class="tabs">
    <div
      v-if="currentTabIndex"
      class="left_block"
      :style="{ left: `calc(${currentTabIndex * 180}px - 6px)` }"
    >
      <div />
    </div>
    <div
      v-for="(item, index) in list"
      :key="index"
      class="tab"
      :class="{ tab_active: currentTabIndex == index }"
      @click="changTabs(index)"
    >
      <span class="pr">
        {{ item.name }}
        <div v-if="item.showPoint && unreadNum" class="red_point" />
      </span>
    </div>
    <div
      class="right_block"
      :style="{ left: `${(currentTabIndex + 1) * 180}px` }"
    >
      <div />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  props: {
    circle_id: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {
      currentTabIndex: 0,
      list: [
        {
          name: "圈友互动",
          type: 1,
          showPoint: false,
        },
        {
          name: "问答",
          type: 2,
          showPoint: true,
        },
      ],
      unreadNum: 0,
    };
  },
  mounted() {},
  methods: {
    changTabs(index) {
      this.currentTabIndex = index;
      this.$parent.getChatMessageList2({
        circle_id: this.circle_id,
        type: this.list[this.currentTabIndex].type,
      });
      if (index === 1) {
        this.changeMyUnReadNum(0);
      }
    },
    changeMyUnReadNum(e) {
      this.unreadNum = e;
    },
  },
};
</script>

<style scoped>
.tabs {
  position: relative;
  width: 100%;
  display: flex;
  height: 40px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  border-bottom: 1px solid #dfdfdf;
}

.left_block,
.right_block {
  position: absolute;
  top: 1px;
  width: 6px;
  height: 100%;
  box-sizing: border-box;
  background-color: #f0f0f0;
}

.left_block div,
.right_block div {
  position: absolute;
  top: -1px;
  width: 100%;
  height: 100%;
  background-color: #f9f9f9;
  border-bottom: 1px solid #dfdfdf;
  z-index: 1;
}

.left_block div {
  border-radius: 0 0 6px 0;
  border-right: 1px solid #dfdfdf;
}

.right_block div {
  border-radius: 0 0 0 6px;
  border-left: 1px solid #dfdfdf;
}

.tab {
  width: 180px;
  height: 100%;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid #dfdfdf;
}

.red_point {
  position: absolute;
  top: 0;
  right: -5px;
  width: 8px;
  height: 8px;
  display: block;
  border-radius: 50%;
  background-color: #e83e3e;
}

.tab_active {
  position: relative;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  background-color: #f0f0f0;
}

.tab_active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 1px;
  background-color: #f0f0f0;
}
</style>
